//import Swiper from 'swiper';
import Alpine from "alpinejs";
import Clipboard from "@ryangjchandler/alpine-clipboard";
import mask from '@alpinejs/mask'
import sticky from 'alpinejs-sticky'
import auth from './plugins/auth.js';
import editor from './editor/core/editor.js';
import forms from './plugins/forms.js';
import events from './plugins/events.js'; 
import tabs from './plugins/tabs.js'; 
import { reinitializePlugins } from './plugins/pluginUtils';
import documentPage from './pages/document.js'; 
import NotyfUtil from './editor/utils/notyf';
import ClipboardJS from 'clipboard';

Alpine.plugin(Clipboard);

import request from 'oc-request';
import flatpickr from "flatpickr";
import { monthSelectPlugin } from "flatpickr/dist/plugins/monthSelect/index.js";

const Russian = require("flatpickr/dist/l10n/ru.js").default.ru;
flatpickr.localize(Russian); 


// Добавляем в Alpine.js store
document.addEventListener('alpine:init', () => {
    // Добавляем в store
    Alpine.store('utils', {
        reinitializePlugins
    });
 
    Alpine.data('forms', forms);
    Alpine.data('auth', auth);
    Alpine.data('editor', editor);
    Alpine.data('events', events);
    Alpine.data('documentPage', documentPage); 
    Alpine.data('tabs', tabs); 
    Alpine.plugin(sticky);

    Alpine.data('templateData', () => ({
        eventModule: null,
        mobileMenuOpen: false,

        init() {
            // Инициализация модуля событий
            this.eventModule = events();
            
            // Инициализируем плагины
            Alpine.store('utils').reinitializePlugins();

            // Регистрируем обработчики событий
            this.eventModule.on('user_dont_coin', (data) => {
                NotyfUtil.error('Недостаточно монет для выполнения операции');
            });

            this.eventModule.on('error', (data) => {
                NotyfUtil.error(data.message || 'Произошла ошибка');
            });

            this.eventModule.on('success', (data) => {
                NotyfUtil.success(data.message || 'Операция выполнена успешно');
            });

            this.eventModule.on('warning', (data) => {
                NotyfUtil.warning(data.message || 'Внимание!');
            });

            this.eventModule.on('update', (data) => {
                if (data.reload) {
                    window.location.reload();
                } else if (data.redirect) {
                    window.location.href = data.redirect;
                }
            });

            // Инициализация других компонентов
            flatpickr(".js-flatpicker");
            var clipboard = new ClipboardJS('.js-copy');

            clipboard.on('success', (e) => {
                NotyfUtil.success('Скопировано!');
                e.clearSelection();
            });
        },

        flatpickrs(ref, options) {
            flatpickr(ref, options);
        },

        request(hendler, options) {
          return request.sendData(hendler, options);
        },

        fetchPartial(partial, target, data) {
            request.sendData('Ajax::onPartial', {
                data: data,
                update: { [partial]: target },
                loading: '.preloader-selector'
            });
        },

        switchProject(projectId) {
            request.sendData('ProjectManager::onSwitchProject', {
                data: { project_id: projectId },
                loading: '.preloader-selector',

                success: () => {
                    window.location.href = '/';
                }
            });
        }

    }));
});

Alpine.start();
